import { RATING_CONFIG_BY_TYPE, RATING_TYPES } from './constants'
import { Podium } from './Place/Podium/Podium'
import { RatingList } from './Place/RatingList'
import { RATING_ICONS } from './Place/constants'

export const getCurrentRatingByRatingType = ({
     ratingLists,
     selectedRatingType,
   }) => ratingLists.find((rating) => rating.ratingType === selectedRatingType);

export const getCurrentPlaceFromRating = (rating) =>
  rating.positions.find((position) => position.isCurrent);

export const getRatingDescription = ({
   period,
   ratingType,
   currentPlace,
 }) =>
  `${RATING_CONFIG_BY_TYPE[ratingType].ratingParam} за ${period} — ${currentPlace.score} ${RATING_CONFIG_BY_TYPE[ratingType].scoreUnits}`;

export const getRatingComponent = (rating, ratingIcon) => {
  switch (ratingIcon) {
    case RATING_ICONS.smile:
      return rating.positions[0].place === 1 ? Podium : RatingList;
    case RATING_ICONS.boat:
      return RatingList;
  }
};

export const getInitialRatingType = (ratingLists) => {
  const isContainsTotalAmountRating = ratingLists.some(
    (ratingList) => ratingList.ratingType === RATING_TYPES.totalAmount,
  );

  // Если рейтингов больше одного - по умолчанию отображаем по объему (TOTAL_AMOUNT)
  return ratingLists.length > 1 && isContainsTotalAmountRating
    ? RATING_TYPES.totalAmount
    : ratingLists[0].ratingType;
};

export const getSortedRatingTypes = (ratingLists) => {
  const ratingTypes = ratingLists.map((ratingList) => ratingList.ratingType);
  const initialRatingType = getInitialRatingType(ratingLists);

  return [...ratingTypes].sort((ratingType1, ratingType2) => {
    if (ratingType1 === initialRatingType) {
      return -1;
    }

    if (ratingType2 === initialRatingType) {
      return 1;
    }

    return 0;
  });
};
